import React from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import COLORS from "../../../../constants/colors";
import { RadioButton, IconContainer, ContentContainer, ChildrenContainer, IconWrapper } from "./styled";

const { UnselectedRadioButton, SelectedRadioButton, CorrectRadioButton, IncorrectRadioButton } = RadioButton;
const ICON_MAP = { check: CheckOutlined, close: CloseOutlined };

const AnswerOption = ({ type, children, value }) => {
  let RadioButtonType = UnselectedRadioButton;
  let iconType = "";
  let color = "";

  switch (type) {
    case "selected":
      RadioButtonType = SelectedRadioButton;
      iconType = "";
      color = COLORS.BLUE;
      break;

    case "correct":
      RadioButtonType = CorrectRadioButton;
      iconType = "check";
      color = COLORS.GREEN;
      break;

    case "incorrect":
      RadioButtonType = IncorrectRadioButton;
      iconType = "close";
      color = COLORS.RED;
      break;

    default:
      RadioButtonType = UnselectedRadioButton;
      iconType = "";
      color = COLORS.GREY;
      break;
  }

  return (
    <RadioButtonType value={value}>
      <ContentContainer>
        <ChildrenContainer>{children}</ChildrenContainer>
        {iconType && (() => {
          const IconComp = ICON_MAP[iconType];
          return IconComp ? (
            <IconContainer>
              <IconWrapper><IconComp style={{ fontSize: "25px", fontWeight: "bold", color }} /></IconWrapper>
            </IconContainer>
          ) : null;
        })()}
      </ContentContainer>
    </RadioButtonType>
  );
};

export default AnswerOption;
